import Icon from "../../../../../components/_ui/_blocks/Icon/Icon";

interface Props {
    children: React.ReactNode;
}

const Notification = ({ children }: Props) => (
    <div className="flex gap-050 items-center">
        <Icon icon="info-status" size="medium" alt="Information" />
        <div className="type-090">{children}</div>
    </div>
);

export default Notification;
